import { render, staticRenderFns } from "./VendorDetailPage.vue?vue&type=template&id=423dd5bc&scoped=true&"
import script from "./VendorDetailPage.vue?vue&type=script&lang=js&"
export * from "./VendorDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./VendorDetailPage.vue?vue&type=style&index=0&id=423dd5bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423dd5bc",
  null
  
)

export default component.exports